import { MissionIntro } from "@/components/about/MissionIntro";
import { FounderStory } from "@/components/about/FounderStory";
import { LifecycleList } from "@/components/about/LifecycleList";
import { FrameworkCta } from "@/components/about/FrameworkCta";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-2">Our Mission</p>
      <h1 className="font-display font-extrabold uppercase text-3xl md:text-5xl text-zinc-950 tracking-tight mb-6">
        More than data. A path to change.
      </h1>

      <MissionIntro />

      <FounderStory />

      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-3">The Full Lifecycle</p>
      <h2 className="font-display font-extrabold uppercase text-2xl md:text-3xl text-zinc-950 tracking-tight mb-4">
        BBAP does not exist just to collect data
      </h2>
      <p className="text-zinc-600 leading-relaxed mb-10 max-w-2xl">
        Collecting documented bias behavior is step one. The point of collecting it is to use it — to push for
        real, structural change. Here's the full lifecycle, end to end:
      </p>

      <LifecycleList />

      <FrameworkCta />
    </div>
  );
}
